import { GenIcon, IconBaseProps, IconType } from "react-icons";

export const SidePeekIcon: IconType = (props: IconBaseProps) =>
  GenIcon({
    tag: "svg",
    attr: {
      width: "14",
      height: "11",
      viewBox: "0 0 14 11",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
    },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.8265 0.233398C1.76247 0.233398 0.899902 1.09596 0.899902 2.15999V8.35078C0.899902 9.41481 1.76247 10.2774 2.8265 10.2774H11.6705C12.7345 10.2774 13.5971 9.41481 13.5971 8.35078V2.15999C13.5971 1.09597 12.7345 0.233398 11.6705 0.233398H2.8265ZM2.0999 2.15999C2.0999 1.75871 2.42521 1.4334 2.8265 1.4334H11.6705C12.0718 1.4334 12.3971 1.75871 12.3971 2.15999V8.35078C12.3971 8.75207 12.0718 9.07737 11.6705 9.07737H2.8265C2.42521 9.07737 2.0999 8.75207 2.0999 8.35078V2.15999ZM8.39594 2.0128C7.84365 2.0128 7.39594 2.46051 7.39594 3.0128V7.49838C7.39594 8.05066 7.84365 8.49838 8.39594 8.49838H10.8179C11.3702 8.49838 11.8179 8.05066 11.8179 7.49838V3.0128C11.8179 2.46051 11.3702 2.0128 10.8179 2.0128H8.39594Z",
          fill: "currentColor",
        },
        child: [],
      },
    ],
  })(props);

export default SidePeekIcon;
